export default __webpack_public_path__ + "static/media/delete1.2c527681.svg";